import {
	dispatchAcknowledgedEvent,
	openResourceSection,
} from '../../core/resourceEvents';
import {
	SWITCH_MAC_ACL_FILTER_EVENT,
	SWITCH_MAC_ACL_FOCUS_EVENT,
	SWITCH_MAC_ACL_SECTION_EVENT,
} from './events';

const SECTIONS = new Set(['profile.switch_mac_acls']);

/**
 * Open Access Controls and bring Switch MAC ACL into view.
 *
 * Five collections share this one accordion, and two of them are behind an
 * inner tab pair, so the section is named per collection rather than per
 * accordion - the page selects the tab when it needs to.
 *
 * @return {Promise<void>} completion acknowledgement
 */
export function openSwitchMacAclSection() {
	return openResourceSection(
		SWITCH_MAC_ACL_SECTION_EVENT,
		'profile.switch_mac_acls',
		SECTIONS,
	);
}

/**
 * Filter the Switch MAC ACL table to a search term.
 * @param {string} query search text
 * @return {Promise<void>} acknowledgement
 */
export function applySwitchMacAclFilter(query) {
	return dispatchAcknowledgedEvent(SWITCH_MAC_ACL_FILTER_EVENT, {
		query: String(query || '').trim(),
		resource: 'switch_mac_acl',
	});
}

/**
 * Point at one Switch MAC ACL row in the table.
 * @param {string} entityId identifier
 * @return {Promise<void>} acknowledgement
 */
export function focusSwitchMacAcl(entityId) {
	if (!entityId) return Promise.reject(new Error('invalid_switch_mac_acl_focus'));
	return dispatchAcknowledgedEvent(SWITCH_MAC_ACL_FOCUS_EVENT, {
		entityId: String(entityId),
		resource: 'switch_mac_acl',
	});
}
